import axios from 'axios';
import { API_BASE_URL } from './utils/apiConfig';

export class FilterItem {
    constructor(item, department, aisle, shelf) {
        this.item = item;
        this.department = department;
        this.aisle = aisle;
        this.shelf = shelf;
    }
}

export class Item {
    constructor(id, name, price, image, description, nutrition = null) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.image = image;
        this.description = description;
        this.nutrition = nutrition;
    }
}

export class Nutrition {
    constructor(ingredients, warnings, calories, totalFat, monounsaturatedFat, polyunsaturatedFat, transFat, totalCarbs, totalSugars, addedSugar, cholesterol, sodium, fiber, protein, iron, servingSize, servingsPerContainer) {
        this.ingredients = ingredients;
        this.warnings = warnings;
        this.calories = calories;
        this.totalFat = totalFat;
        this.monounsaturatedFat = monounsaturatedFat;
        this.polyunsaturatedFat = polyunsaturatedFat;
        this.transFat = transFat;
        this.totalCarbs = totalCarbs;
        this.totalSugars = totalSugars;
        this.addedSugar = addedSugar;
        this.cholesterol = cholesterol;
        this.sodium = sodium;
        this.fiber = fiber;
        this.protein = protein;
        this.iron = iron;
        this.servingSize = servingSize;
        this.servingsPerContainer = servingsPerContainer;
    }
}

export function makeItem(id, name, price, finalImagePath, description, ingredients, warnings, calories, totalFat, monounsaturatedFat,
    polyunsaturatedFat, transFat, totalCarbs, totalSugars, addedSugar, cholesterol, sodium,
    fiber, protein, iron, servingSize, servingsPerContainer) {
    return new Item(
        id,
        name,
        price || "",
        finalImagePath,
        description || "",
        new Nutrition(
            ingredients || "",
            warnings || "",
            calories || 0,
            totalFat || 0,
            monounsaturatedFat || 0,
            polyunsaturatedFat || 0,
            transFat || 0,
            totalCarbs || 0,
            totalSugars || 0,
            addedSugar || 0,
            cholesterol || 0,
            sodium || 0,
            fiber || 0,
            protein || 0,
            iron || 0,
            servingSize || "",
            servingsPerContainer || ""
        )
    );
}

export async function fetchProducts(page = 1) {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/request?page=${page}`);
    
        const { products, totalPages } = response.data;

        const mappedProducts = products.map(p => {
            const rawImage = p.productImage || p.image;
            const image = (rawImage && rawImage !== "autoFill.jpg")
                ? `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/${rawImage}`
                : `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/autoFill.jpg`; 
            
            return makeItem(
                p.productId || p.id,
                p.productName || p.name,
                p.price,
                image,
                p.productDescription || p.description,
                p.ingredients,
                p.productWarnings || p.warnings,
                p.calories,
                p.totalFat,
                p.monounsaturatedFat,
                p.polyunsaturatedFat,
                p.transFat,
                p.totalCarbs,
                p.totalSugars,
                p.addedSugar,
                p.cholesterol,
                p.sodium,
                p.fiber,
                p.protein,
                p.iron,
                p.servingSize,
                p.servingsPerContainer
            );
        });
        return { products: mappedProducts, totalPages };
    } catch (err) {
        console.error("fetchProducts Failed: ", err);
        throw err;
    }
}

export async function fetchProductById(id) {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/product/${id}`);
        const p = response.data;
        const rawImage = p.productImage || p.image;
        const image = (rawImage && rawImage !== "autoFill.jpg")
            ? `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/${rawImage}`
            : `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/autoFill.jpg`;

        return makeItem(
            p.productId || p.id,
            p.productName || p.name,
            p.price,
            image,
            p.productDescription || p.description,
            p.ingredients,
            p.productWarnings || p.warnings,
            p.calories,
            p.totalFat,
            p.monounsaturatedFat,
            p.polyunsaturatedFat,
            p.transFat,
            p.totalCarbs,
            p.totalSugars,
            p.addedSugar,
            p.cholesterol,
            p.sodium,
            p.fiber,
            p.protein,
            p.iron,
            p.servingSize,
            p.servingsPerContainer
        );
    } catch (err) {
        console.error("fetchProductById Failed: ", err);
        throw err;
    }
}

export async function fetchProductsByCategory(category, page = 1, aisle = null) {
    try {
        const url = aisle
            ? `${API_BASE_URL}/api/products/aisle/${encodeURIComponent(aisle)}?page=${page}`
            : `${API_BASE_URL}/api/products/category/${category}?page=${page}`;

        const response = await axios.get(url);
        
        const dataArray = response.data.products || response.data;
        const totalPages = response.data.totalPages || 1;

        const mappedProducts = dataArray.map(p => {
            const rawImage = p.productImage || p.image;
            const image = (rawImage && rawImage !== "autoFill.jpg")
                ? `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/${rawImage}`
                : `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/autoFill.jpg`;

            return makeItem(
                p.productId || p.id,
                p.productName || p.name,
                p.price,
                image,
                p.description || p.productDescription,
                p.ingredients,
                p.warnings || p.productWarnings,
                p.calories,
                p.totalFat,
                p.monounsaturatedFat,
                p.polyunsaturatedFat,
                p.transFat,
                p.totalCarbs,
                p.totalSugars,
                p.addedSugar,
                p.cholesterol,
                p.sodium,
                p.fiber,
                p.protein,
                p.iron,
                p.servingSize,
                p.servingsPerContainer
            );
        });

        return { products: mappedProducts, totalPages };
    } catch (err) {
        console.error("fetchProductsByCategory Failed: ", err);
        throw err;
    }
}

export async function fetchProductsByFilter(filter, operator, value, page = 1, category = null, aisle = null, value2 = null) {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/products/filter/${filter}?page=${page}`, {
            operator: operator,
            value: value,
            value2: value2, // Pass the second value for BETWEEN queries
            category: category,
            aisle: aisle
        });

        const items = response.data.products.map(p => {
            const rawImage = p.productImage || p.image;
            const finalImage = (rawImage && rawImage !== "autoFill.jpg")
                ? `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/${rawImage}`
                : `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/autoFill.jpg`;

            return makeItem(
                p.productId || p.id, 
                p.productName || p.name, 
                p.price, 
                finalImage,
                p.productDescription || p.description, 
                p.ingredients, 
                p.productWarnings || p.warnings, 
                p.calories, 
                p.totalFat, 
                p.monounsaturatedFat, 
                p.polyunsaturatedFat, 
                p.transFat, 
                p.totalCarbs, 
                p.totalSugars, 
                p.addedSugar, 
                p.cholesterol, 
                p.sodium, 
                p.fiber, 
                p.protein, 
                p.iron, 
                p.servingSize, 
                p.servingsPerContainer
            );
        });

        return { products: items, totalPages: response.data.totalPages };
    } catch (err) {
        console.error("fetchProductsByFilter Failed: ", err);
        throw err;
    }
}